import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import Spoiler from '../../../../../../../../../../../components/Spoiler'
import ToggleField from '../../../../../../../../../../../components/Form/ToggleField'

import { getAllocationInfo } from '../../helpers'

import {
  ADVANCED_SETTINGS,
  AD_INVENTORY_TARGETING_ENABLED,
  IS_SUB_ALLOCATION,
  CUSTOM_TARGETING_ENABLED,
  SKIPPABLE_ADS_ENABLED,
  GEO_TARGETING_ENABLED,
  DEVICE_TARGETING_ENABLED
} from '../../../fields'

import useDrawerFormStyles from '../../../../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const AdvancedSettings = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const { values, setFieldValue } = formik

  const advancedSettings = values[ADVANCED_SETTINGS]

  const { isPercentageAllocation } = getAllocationInfo(values)

  return (
    <Spoiler
      title={t('Advanced settings')}
      className={classes.spoiler}
      spoilerTitleClassName={classes.spoilerTitle}
      arrowIconClassName={classes.arrowIcon}
    >
      <section className={classnames(drawerFormClasses.section, classes.advancedSettingsSection)}>
        <p className={classes.advancedSettingsDescription}>{t('Enable/disable the following features for sponsors')}</p>
        <div className={classes.advancedSettingsContainer}>
          <ToggleField
            name={`${ADVANCED_SETTINGS}.${SKIPPABLE_ADS_ENABLED}`}
            setFieldValue={setFieldValue}
            isEnabled={advancedSettings[SKIPPABLE_ADS_ENABLED]}
            label="Skippable ads "
          />
          {!values[IS_SUB_ALLOCATION] && (
            <ToggleField
              name={`${ADVANCED_SETTINGS}.${AD_INVENTORY_TARGETING_ENABLED}`}
              setFieldValue={setFieldValue}
              isEnabled={advancedSettings[AD_INVENTORY_TARGETING_ENABLED]}
              label="Ad inventory targeting"
            />
          )}
          {!isPercentageAllocation && (
            // For any sponsorship right do not show any of Geo-targeting,Device & browser targeting or Custom targeting.
            // Automatically disable all of them in the right
            <>
              <ToggleField
                name={`${ADVANCED_SETTINGS}.${GEO_TARGETING_ENABLED}`}
                setFieldValue={setFieldValue}
                isEnabled={advancedSettings[GEO_TARGETING_ENABLED]}
                label={'Geo-targeting'}
              />
              <ToggleField
                name={`${ADVANCED_SETTINGS}.${DEVICE_TARGETING_ENABLED}`}
                setFieldValue={setFieldValue}
                isEnabled={advancedSettings[DEVICE_TARGETING_ENABLED]}
                label={'Device Category, Browser Language, Device Manufacturer, Operating System'}
              />
              <ToggleField
                name={`${ADVANCED_SETTINGS}.${CUSTOM_TARGETING_ENABLED}`}
                setFieldValue={setFieldValue}
                isEnabled={advancedSettings[CUSTOM_TARGETING_ENABLED]}
                label={'Custom key-values, Content & Metadata'}
              />
            </>
          )}
        </div>
      </section>
    </Spoiler>
  )
}

export default AdvancedSettings
